'use client';

import React from 'react';

import {
  NavbarBase,
  Container,
  Group,
} from './Navbar.styled';
import Logo from './Logo';

import type { NavbarProps } from './Navbar';

function NavbarLoading({ logo }: NavbarProps) {
  return (
    <NavbarBase>
      <Container>
        <Logo {...logo} />
        <Group />
      </Container>
    </NavbarBase>
  );
}

export default NavbarLoading;
